import { render, staticRenderFns } from "./IconSvgJs.vue?vue&type=template&id=c65e9dce&scoped=true&"
import script from "./IconSvgJs.vue?vue&type=script&lang=js&"
export * from "./IconSvgJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65e9dce",
  null
  
)

export default component.exports